import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "14", x: "2", y: "5", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "10", x: "16", y: "7", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 2v20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AlignHorizontalJustifyCenter";
const AlignHorizontalJustifyCenter = memo(themed(Icon));
export {
  AlignHorizontalJustifyCenter
};
//# sourceMappingURL=align-horizontal-justify-center.js.map
